<template>
    <dialog-selector
        width="644px"
        class="department-dialog-selector"
        :data="groupData"
        :title="title"
        v-on="$listeners"
        :showSidebar="false"
        :showSearch="false"
        :disabled-collapse="true"
        v-bind="$attrs"
    >
    </dialog-selector>
</template>
<script>
    import DialogSelector from '@/components/dialog-selector';
    import UtilsMixins from '@/mixins/utils'
    export default {
        name: 'DepartmentDialogSelector',
        components: {
            DialogSelector,
        },
        mixins: [UtilsMixins],
        props: {
            groupData: {
                type: Array,
                default: () => []
            },
            title: {
                type: String,
                default: () => '选择部门'
            }
        },
        data() {
            return {
                
            }
        },
        methods: {
            
        },
        mounted() {
            
        }
    }
</script>
<style lang="scss">
.department-dialog-selector {
    color: black;
    box-shadow: 0 1px 13px 0 rgba(0,0,0,0.15);
    border-radius: 6px;
    .dialog-selector .dialog-selector__content .group-header__icon {
        visibility: hidden;
    }
    .dialog-selector .dialog-selector__content .dialog-selector__group-header label.el-checkbox{
        margin-left: 1px;
    }
    .el-dialog {
        border-radius: 6px;
    }
    .el-dialog__header {
        text-align: left;
        height: 48px;
        .el-dialog__headerbtn {
            float: right;
            border: none;
            background: white;
        }
        .el-dialog__close {
            font-size: 16px;
        }
        .dialog-selector__header {
            line-height: 33px;
        }
    }
    .dialog-selector__content {
        margin: 0;
        height: 240px;
    }
    .el-dialog__body {
        .dialog-selector__main {
            padding-top: 20px;
        }
    }
}
    
</style>